import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {Card, CardBody,Modal,ModalHeader,Button,Label,Input} from "reactstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Table from 'react-bootstrap/Table';
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { v4 as uuidv4 } from 'uuid';
import axios from "axios";
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import 'jspdf-autotable';

export default function Failedcertificates() {
    const [agent, setAgent] = useState('')
    const [agentCode, setAgentcode] = useState('')
    const [certificates, setCertificates] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const [modal,setModal] = useState(false)
    const [modal2,setModal2] = useState(false)
    const [isCert, setIscert] = useState(0)
    const rowsPerPage = 20;
    const totalPages = Math.ceil(certificates.length / rowsPerPage);
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentPolicies = certificates.slice(indexOfFirstRow, indexOfLastRow)
    const [search, setSearch] = useState('')
    const [today, setToday] = useState(null)
    const [certURL, setCertURL] = useState('')
    const [certError, setCerterror] = useState('')
    const [credentials, setCredentials] = useState(null)
    const [isAuth, setIsauth] = useState(false)
    const [pin, setPin] = useState('')
    const [clientEmail, setClientEmail] = useState('')
    const [insuredItem,setInsuredItem] = useState('')  
    const [commencementDate, setCommencementDate] = useState('')
    const [expiryDate, setExpiryDate] = useState('') 
    const [periodOfCover, setPeriodOfCover] = useState('')  
    const [showDatePicker, setShowDatePicker] = useState(false)
    const [updateText, setUpdateText] = useState('Save changes')  
    const [client, setClient] = useState('')
    const [note,setNote] = useState('')
    const [proposal, setProposal] = useState('')  
    const [certNo, setCerno] = useState('')
    const company = 'Definite'

        useEffect(()=>{
        const now = new Date();
        
        // Format YYYY-MM-DD
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        
        // Format HH:mm:ss.SSS
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        const milliseconds = String(now.getMilliseconds()).padStart(3, '0');
        
        

        setToday(`${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`)

        },[])

        
          useEffect(()=>{
          const getCredentials =async()=>{
            const res = await fetch(`https://digitalapi.definiteassurance.com/api/getCredentials?username=${company}`)
            const data = await res.json();
            const {Username, Password} = data;
            const cred = btoa(`${Username}:${Password}`)
            setCredentials(btoa(`${Username}:${Password}`))
            setIsauth(true)
        
        
          }
          getCredentials()
        
          },[])
        
    
            useEffect(() => {
          
            const user = localStorage.getItem('definiteagent'); // Retrieve email
            if (user) {
                
                setAgent(user)
            } else {
            
            }
            }, []);
          
            useEffect(()=>{
                const getAgentcode =async()=>{
                    const res =await fetch(`https://digitalapi.definiteassurance.com/api/getDealerdetails?email=${agent}`,{
                        method:"GET",
                    headers:{
                      'Authorization': `Basic ${credentials}`,
                      'Content-Type': "application/json"
                    }
                    });
                    const data = await res.json();
                    setAgentcode(data.OID)   
          
                }
                if(agent && isAuth){
                    getAgentcode()
                }
            },[agent,isAuth])
    
    
            useEffect(()=>{
                const getCertificates =async()=>{
                    const res = await fetch(`https://digitalapi.definiteassurance.com/api/getFailedcertificates?code=${agentCode}`,{
                           method:"GET",
                    headers:{
                      'Authorization': `Basic ${credentials}`,
                      'Content-Type': "application/json"
                    }
                    })
                    const data = await res.json();
                    setCertificates(data)
                }
    
                if(agentCode && isAuth){
                    getCertificates();
                }
    
            },[agentCode, isAuth])
    const getCertificates =async()=>{
                    const res = await fetch(`https://digitalapi.definiteassurance.com/api/getFailedcertificates?code=${agentCode}`,{
                           method:"GET",
                    headers:{
                      'Authorization': `Basic ${credentials}`,
                      'Content-Type': "application/json"
                    }
                    })
                    const data = await res.json();
                    setCertificates(data)
                }
    
            useEffect(()=>{
                const getCertificates =async()=>{
                    const res = await fetch(`https://digitalapi.definiteassurance.com/api/getSearchcertificates?code=${agentCode}&search=${search}`,{
                           method:"GET",
                    headers:{
                      'Authorization': `Basic ${credentials}`,
                      'Content-Type': "application/json"
                    }
                    })
                    const data = await res.json();
                    setCertificates(data)
                }
    
                if(search && isAuth){
                    getCertificates();
                }
    
            },[search,isAuth])
    function formateDateISO(input) {
        // Handle null or undefined input
        if (input === null || input === undefined || input === '') {
            return null; // or return an empty string "" depending on your needs
        }
        
        // Handle string input
        if (typeof input === 'string') {
            if (!input) return null; // handle empty string
            return input.split('T')[0];
        }
        
        // Handle Date object
        if (input instanceof Date) {
            // Check if the date is valid
            if (isNaN(input.getTime())) {
                throw new Error('Invalid Date object');
            }
            return input.toISOString().split('T')[0];
        }
        
        throw new Error('Invalid input: Expected ISO String, Date Object, or null');
    }

    const getCertdetails =async(e)=>{
        const insuredItem = e.target.value;

        const res = await fetch(`https://digitalapi.definiteassurance.com/api/getCertdetails?insured=${insuredItem}`,{
               method:"GET",
                    headers:{
                      'Authorization': `Basic ${credentials}`,
                      'Content-Type': "application/json"
                    }
                    
        })
        const data = await res.json()
        const {Proposal,ValidFrom,ExpiryDate,Capacity,Tonnage,SumInsured} = data;
        setModal(true)

        const activity = `Starting to generate Certificate for ${Proposal} by retry`
        insertLog(agentCode,activity)

       const res3 = await axios.post('https://sms.definiteassurance.com/webhook/c924c7c4-d115-4724-a78c-27048b99b6f0',{IOID:insuredItem,commencementUnix:ValidFrom,expiryUnix:ExpiryDate,sumInsured:SumInsured,capacity:Capacity,tonnage:Tonnage})
        //const res3 = await axios.post('https://workflows.uuidesign.xyz/webhook/c924c7c4-d115-4724-a78c-27048b99b6f0',{IOID:insuredItem,commencementUnix:ValidFrom,expiryUnix:ExpiryDate,sumInsured:SumInsured,capacity:Capacity,tonnage:Tonnage})
       
        if(res3.data.success){
            insertCertificate(res3.data.certURL,res3.data.certNo,Proposal,ValidFrom,ExpiryDate,insuredItem)
            const activity = `Certificate for ${Proposal} generated by retry`
            insertLog(agentCode,activity)
            setCertURL(res3.data.certURL)

            setTimeout(() => {
                setIscert(1)
            }, 3000); 
            
            
        }
        else{
            setIscert(2)
            setCerterror(res3.data.errorMessage)
            const activity = `Certificate for ${reg} error-${res3.data.errorMessage}`
            insertLog(agentCode,activity)
        }
        
        }


    const insertCertificate=async(certLink,certNo,Proposal,ValidFrom,ExpiryDate,insuredItem)=>{
    const res = await fetch('https://digitalapi.definiteassurance.com/api/insertCertificate',{
       method:"POST",
        headers:{
            'Authorization': `Basic ${credentials}`,
            'Content-Type': "application/json"
        },
        body:JSON.stringify({proposalOID:Proposal,insuredOID:insuredItem,expiryUnix:ExpiryDate,commencementUnix:ValidFrom,certNo,certLink,today})
    })

    const data = await res.json()
    }

        const insertLog=async(agent,activity)=>{
        const res = await fetch(`https://digitalapi.definiteassurance.com/api/insertLogs?activity=${activity}&agent=${agent}`,{
             method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
        });
        const data = await res.json()
    }

    const closeModal =()=>{
        setIscert(0)
        setCertURL('')
        setModal(false)
    }

    const handleCommencementDateChange = (e) => {
        const selectedDate = e.target.value; // This will be in YYYY-MM-DD format from input type="date"
        
        // Convert to ISO format with current time
        const dateObj = new Date(selectedDate);
        const isoString = dateObj.toISOString(); // Format: 2025-10-24T00:43:04.470Z
        
        setCommencementDate(isoString);
        
        // Auto-calculate expiry date: commencementDate + periodOfCover days
        if (periodOfCover) {
            const expiryDateObj = new Date(dateObj);
            expiryDateObj.setDate(expiryDateObj.getDate() + parseInt(periodOfCover));
            const expiryIsoString = expiryDateObj.toISOString();
            setExpiryDate(expiryIsoString);
        }
    }

    //edit details

    const editDetails =async(e)=>{
        const pr = e.target.value;
        setProposal(pr)
         const res = await fetch(`https://digitalapi.definiteassurance.com/api/getCertificatedetails?proposal=${pr}`,{
             method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
        });
        const data = await res.json();
        const {InsuredItem,DealerPin,Email,PeriodOfCover,Client,CertNo} = data;
        setInsuredItem(InsuredItem);
        setPin(DealerPin);
        setClientEmail(Email);  
        setPeriodOfCover(PeriodOfCover);
        setCerno(CertNo)
        setClient(Client)
         const res2 = await fetch(`https://digitalapi.definiteassurance.com/api/getFailedcertnote?proposal=${pr}`,{
             method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
        });
        const data2 = await res2.json();   
        const {CommencementDate, ExpiryDate,Note} = data2;
        setCommencementDate(CommencementDate);
        setExpiryDate(ExpiryDate);
        setNote(Note);
        //open modal
        setModal2(true)
    }

    const saveChanges =async()=>{
        setUpdateText('Saving...')
       const res2 = await fetch(`https://digitalapi.definiteassurance.com/api/updateFailedCert`,{
             method:"POST",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
                ,
                body:JSON.stringify({commencementDate,expiryDate,proposal,clientEmail,pin,note,client,certNo})
        });
        const data2 = await res2.json();    
        const {success} = data2;
        if(success){
            toast.success('Details updated successfully!')
            setUpdateText('Save changes')
            getCertificates()
            setModal2(false)
        }
        else{
            toast.error('Failed to update details. Please try again.')
            setUpdateText('Save changes')
        }         
    
    }

  return (
     <div className="page-content">
        <ToastContainer />
         <Breadcrumbs title="Definite Assurance" breadcrumbItem={`Failed Certificates`} />
            <Card className="mini-stats-wid">
                <CardBody>
                      <div className="searchInput">
                         <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Search registration" onChange={(e)=>{setSearch(e.target.value)}}>
                            <Form.Control  className='inputSearch' value={search}  type="text" placeholder="Search" />
                        </FloatingLabel>
                    </div>
                                    <div className="table-responsive" style={{padding:'10px'}}>
                    
                    
                                    <Table striped bordered hover id="policy-table">
                                    <thead>
                                        <tr>
                                        <th scope="col">#</th>
                                         <th scope="col">Proposal No</th>
                                         <th scope="col">Item</th>
                                        <th scope="col">Registration</th>
                                        <th scope="col">Valid From</th>     
                                        <th scope="col">Expiry Date</th>
                                        <th scope="col">Actions</th>
                                        
                    
                    
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentPolicies.map((val, index) => {
                                        // Calculate the correct index based on current page
                                        const globalIndex = indexOfFirstRow + index;
                                        const transactionDate = new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(val.DateDone)
                                        const valid = `${val.ValidFrom}`
                                        const Expiry = `${val.ExpiryDate}`
                                            if(certificates.length !== 0){
                                                    return (
                                                    <tr key={index}>
                                                    <td>{index + 1}</td>
                                                     <td>{val.OID}</td>
                                                      <td>{val.InsuredItem}</td>
                                                    <td>{val.Narration}</td>
                                                   <td>{formateDateISO(valid)}</td>
                                                  

                                                    <td>{formateDateISO(Expiry)}</td>
                                                      <td><button style={{color:'red'}} className="tableButton" value={val.OID} onClick={editDetails} >EDIT</button></td>
                                                    <td><button className="tableButton2" value={val.InsuredItem} onClick={getCertdetails} >Retry</button></td>
                                                    </tr>
                                                );

                                            }        

                    
                                        })}
                                    </tbody>
                                    </Table>
                    
                                    {/* Pagination controls */}
                                    <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                        Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, certificates.length)} of {certificates.length} entries
                                    </div>
                                    <div>
                                        <button 
                                        className="btn btn-sm btn-outline-primary mx-1"
                                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                        disabled={currentPage === 1}
                                        >
                                        Previous
                                        </button>
                                        
                                        {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                                        <button
                                            key={page}
                                            className={`btn btn-sm mx-1 ${currentPage === page ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => setCurrentPage(page)}
                                        >
                                            {page}
                                        </button>
                                        ))}
                                        
                                        <button 
                                        className="btn btn-sm btn-outline-primary mx-1"
                                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                        disabled={currentPage === totalPages}
                                        >
                                        Next
                                        </button>
                                    </div>
                                    </div>
                                    </div>

                </CardBody>
            </Card>

             <Modal isOpen={modal}>
                <ModalHeader>Certificate Generation</ModalHeader>
                <div className="modalContainer">
                    {isCert == 0 &&
                        <p>Generating Certificates...</p>
                    
                    }

                     {isCert == 2 &&
                        <p>Faile to generate certiificate with error: {certError}</p>
                    
                    }
                    {isCert == 1 &&
                        <>
                        <a style={{backgroundColor:'green',width:'100%',color:'white',padding:'10px',borderRadius:'5px',marginBottom:'20px'}} href={certURL} target="_blank" rel="noreferrer">DONWLOAD CERTIFICATE</a>
                        <p style={{marginTop:'15px'}}>DISCLAIMER: If Certificate does not download, click the 'DOWNLOAD BUTTON' again!</p>
                        </>
                    
                    }


                    <p style={{color:'red',marginTop:'5%',float:'right',cursor:'pointer'}} onClick={closeModal}>CLOSE</p>
                </div>

             </Modal>

             <Modal isOpen={modal2}>
                <ModalHeader>Certificate Details</ModalHeader>
                <div className="modalContainer">

                    <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="CLIENT PIN" onChange={(e)=>{setPin(e.target.value)}}>
                        <Form.Control  className='inputSearch' value={pin}  type="text" placeholder="CLIENT PIN"  />
                    </FloatingLabel>

                    <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="CLIENT EMAIL" onChange={(e)=>{setClientEmail(e.target.value)}}>
                        <Form.Control  className='inputSearch' value={clientEmail}  type="text" placeholder="CLIENT EMAIL"  />
                    </FloatingLabel>

                    {!showDatePicker ? (
                        <>
                            <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="COMMENCEMENT DATE" >
                                <Form.Control  className='inputSearch' value={formateDateISO(commencementDate)}  type="text" placeholder="COMMENCEMENT DATE" disabled />
                            </FloatingLabel>
                            <button 
                                style={{color:'blue',border:'none',backgroundColor:'#ffffff00',marginBottom:'3%'}}
                                onClick={() => setShowDatePicker(true)}
                            >
                                Change commencement date
                            </button>
                        </>
                    ) : (
                        <>
                            <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="SELECT COMMENCEMENT DATE" >
                                <Form.Control  
                                    className='inputSearch' 
                                    type="date" 
                                    placeholder="SELECT COMMENCEMENT DATE" 
                                    onChange={handleCommencementDateChange}
                                />
                            </FloatingLabel>
                            <button 
                                style={{color:'red',border:'none',backgroundColor:'#ffffff00',marginBottom:'3%'}}
                                onClick={() => setShowDatePicker(false)}
                            >
                                Cancel
                            </button>
                        </>
                    )}

                    <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="EXPIRY DATE" >
                        <Form.Control  className='inputSearch' value={formateDateISO(expiryDate)}  type="text" placeholder="EXPIRY DATE" disabled />
                    </FloatingLabel>        
                 
                  <Button color="success" onClick={saveChanges}>{updateText}</Button>
                   
                    <p style={{color:'red',marginTop:'5%',float:'right',cursor:'pointer'}} onClick={() => setModal2(false)}>CLOSE</p>
                </div>
             </Modal>
    </div>

   
  )
}
